/* eslint-disable import/order */
/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';
import { React, useEffect, useState } from 'react';
import './CabSearchResults.scss';
import { formatCurrency } from '../../../shared/helper-utils/appUtils';
import ReactSlider from 'react-slider';
import AppCheckBox from '../../../shared/components/app-check-box/AppCheckBox';
import AppButton from '../../../shared/components/app-button/AppButton';
import { useIntl } from 'react-intl';

function CabFilters({
  minPrice,
  maxPrice,
  selectedFilters,
  vehicleNames,
  serviceTypes,
  onApplyFilter,
  onClearFilters,
}) {
  const intl = useIntl();
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };
  const [selectedMinPrice, setSelectedMinPrice] = useState(minPrice);
  const [selectedMaxPrice, setSelectedMaxPrice] = useState(maxPrice);
  const [selectedVechicleName, setSelectedVechicleName] = useState(
    selectedFilters.vechicleName,
  );
  const [selectedServiceType, setSelectedServiceType] = useState(
    selectedFilters.serviceType,
  );

  useEffect(() => {
    setSelectedMinPrice(minPrice);
    setSelectedMaxPrice(maxPrice);
  }, [minPrice, maxPrice]);

  const handleSliderChange = (newValues) => {
    setSelectedMinPrice(newValues[0]);
    setSelectedMaxPrice(newValues[1]);
    onApplyFilter({
      selectedMinPrice: newValues[0],
      selectedMaxPrice: newValues[1],
      selectedVechicleName,
      selectedServiceType,
    });
  };
  const handleChipSelection = (name, value) => {
    let list = [];
    if (name === 'vehicleName') {
      list = [...selectedVechicleName];
    } else if (name === 'serviceType') {
      list = [...selectedServiceType];
    }
    const index = list.indexOf(value);
    if (index > -1) {
      list.splice(index, 1);
    } else {
      list.push(value);
    }
    if (name === 'vehicleName') {
      setSelectedVechicleName(list);
    } else if (name === 'serviceType') {
      setSelectedServiceType(list);
    }
    if (name === 'vehicleName') {
      onApplyFilter({
        selectedMinPrice,
        selectedMaxPrice,
        selectedVechicleName: list,
        selectedServiceType,
      });
    }
    if (name === 'serviceType') {
      onApplyFilter({
        selectedMinPrice,
        selectedMaxPrice,
        selectedVechicleName,
        selectedServiceType: list,
      });
    }
  };
  const handleClearFilters = () => {
    onClearFilters();
    setSelectedMinPrice(minPrice);
    setSelectedMaxPrice(maxPrice);
    setSelectedVechicleName([]);
    setSelectedServiceType([]);
  };
  return (
    <div className="cab-filters">
      <div className="cab-filters_section fs-14 fw-600">Filters</div>
      <div className="cab-filters_section">
        <div>
          <span className="fs-12">
            {formatCurrency(selectedMinPrice)}-
            {formatCurrency(selectedMaxPrice)}
          </span>
        </div>
        <div className="my-2">
          <ReactSlider
            min={minPrice}
            max={maxPrice}
            defaultValue={[selectedMinPrice, selectedMaxPrice]}
            onChange={handleSliderChange}
          />
        </div>
      </div>
      <div className="cab-filters_section">
        <div className="fs-12 fw-600 mb-2">Vehicle Name</div>
        {vehicleNames.map((vehicleName) => (
          <AppCheckBox
            key={vehicleName}
            labelText={vehicleName}
            name="vehicleName"
            checked={selectedVechicleName.includes(vehicleName)}
            onChange={() => handleChipSelection('vehicleName', vehicleName)}
          />
        ))}
      </div>
      <div className="cab-filters_section">
        <div className="fs-12 fw-600 mb-2">Service Type</div>
        {serviceTypes.map((serviceType) => (
          <AppCheckBox
            key={serviceType}
            labelText={serviceType}
            name="serviceType"
            checked={selectedServiceType.includes(serviceType)}
            onChange={() => handleChipSelection('serviceType', serviceType)}
          />
        ))}
      </div>
      <div className="cab-filters_section">
        <div
          className="d-flex justify-content-center py-2 pb-5"
          style={{ paddingBottom: '150px' }}
        >
          <AppButton
            btnText={formattedMessage('clear_btn')}
            variant="outlined"
            onClick={handleClearFilters}
          />
        </div>
      </div>
    </div>
  );
}

CabFilters.propTypes = {
  minPrice: PropTypes.number.isRequired,
  maxPrice: PropTypes.number.isRequired,
  selectedFilters: PropTypes.object.isRequired,
  vehicleNames: PropTypes.array.isRequired,
  serviceTypes: PropTypes.array.isRequired,
  onApplyFilter: PropTypes.func.isRequired,
  onClearFilters: PropTypes.func.isRequired,
};
export default CabFilters;
